import { Spinner } from '@fluentui/react-components';
import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { connectToTeams, type TeamsHost } from '#src/teams/teams-host';

const TeamsHostContext = createContext<TeamsHost | null>(null);

/**
 * Descobre se a aplicação está dentro do Teams antes de renderizar o resto:
 * o tema e o login dependem disso.
 */
export function TeamsHostProvider({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<TeamsHost | null | undefined>(undefined);

  useEffect(() => {
    connectToTeams().then(setHost, () => setHost(null));
  }, []);

  if (host === undefined) {
    return <Spinner label="Carregando..." style={{ marginTop: '30vh' }} />;
  }
  return (
    <TeamsHostContext.Provider value={host}>
      {children}
    </TeamsHostContext.Provider>
  );
}

/** O Teams que hospeda a aplicação, ou `null` no navegador comum. */
export const useTeamsHost = (): TeamsHost | null =>
  useContext(TeamsHostContext);
